class Config {
  // eslint-disable-next-line no-useless-constructor,no-empty-function
  constructor() {

  }
}
Config.env = 'product';

Config.restUrl = Config.env === 'dev' ? 'http://bustest.vaiwan.com/' : 'https://bus.uu1.com/';
//https://test-bus.uu1.com/

Config.onPay = true; // 是否启用支付

Config.clientSecret = Config.env === 'dev' ? 'czcqMvc2016' : 'js.admin@2020';

Config.clientId = Config.env === 'dev' ? 'czcqMvc' : 'js.admin';

Config.redBagCenterShopCateId = Config.env === 'dev' ? '14' : '4';

export { Config };
